module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": "",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', [_vm._v("AM / CC Inputs")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.campaign) ? _c('v-card-text', {
    staticClass: "body-2 ims-modal-body",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [(_vm.campaign.AMInputs) ? _c('div', [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("AM Inputs")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('div', [_c('label', [_vm._v("Please provide an overview of this campaign brief, include pointers to note for your stakeholders to support in getting the brief approved, ie past conversations with client")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "",
      "readonly": "",
      "outlined": ""
    },
    model: {
      value: (_vm.campaign.AMInputs.remarks),
      callback: function($$v) {
        _vm.$set(_vm.campaign.AMInputs, "remarks", $$v)
      },
      expression: "campaign.AMInputs.remarks"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Deadline")]), _vm._v(" "), _c('v-text-field', _vm._g({
    attrs: {
      "append-icon": "event",
      "outlined": "",
      "readonly": ""
    },
    model: {
      value: (_vm.campaign.AMInputs.deadline),
      callback: function($$v) {
        _vm.$set(_vm.campaign.AMInputs, "deadline", $$v)
      },
      expression: "campaign.AMInputs.deadline"
    }
  }, _vm.on))], 1)]) : _vm._e(), _vm._v(" "), (_vm.campaign.CCInputs) ? _c('div', [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("CC Inputs")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('div', [_c('label', [_vm._v("Please schedule a call with your respective AM to finalise the brief and provide a summary on the following next steps:"), _c('br'), _vm._v("What are you getting out of this campaign brief and type of rejections/challenges or stucks you foresee from the creators")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "",
      "readonly": "",
      "outlined": ""
    },
    model: {
      value: (_vm.campaign.CCInputs.remarks),
      callback: function($$v) {
        _vm.$set(_vm.campaign.CCInputs, "remarks", $$v)
      },
      expression: "campaign.CCInputs.remarks"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Deadline")]), _vm._v(" "), _c('v-text-field', _vm._g({
    attrs: {
      "append-icon": "event",
      "outlined": "",
      "readonly": ""
    },
    model: {
      value: (_vm.campaign.CCInputs.deadline),
      callback: function($$v) {
        _vm.$set(_vm.campaign.CCInputs, "deadline", $$v)
      },
      expression: "campaign.CCInputs.deadline"
    }
  }, _vm.on))], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.isSuperAdmin && _vm.source === 'release') ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.proceedBrief()
      }
    }
  }, [_vm._v("Proceed with brief")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cd3f3c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/AmCcInputsModal.vue
// module id = 2058
// module chunks = 0